import React, { Component } from "react";
import {
  Form,
  Button,
  Image,
  InputGroup,
  OverlayTrigger,
  Tooltip,
  Alert,
} from "react-bootstrap";
import { ILoginState } from "../../interfaces/auth.interface";
import { loginValidator } from "../../helper/validator/login.validator";
import lockIcon from "../../assets/images/auth/lock.png";
import mailIcon from "../../assets/images/auth/mail.png";
import { loginReducer } from "../../reducer/Auth";

class Login extends Component<any, ILoginState> {
  constructor(props: any) {
    super(props);
    this.state = {
      email: "",
      password: "",
      errors: {
        email: "",
        password: "",
      },
      rememberMe: false,
      isClick: false
    };
  }

  componentDidMount() {
    const rememberMe = localStorage.getItem("rememberMe") === "true";
    const email = rememberMe ? localStorage.getItem("email") || "" : "";
    const password = rememberMe ? localStorage.getItem("password") || "" : "";
    this.setState({ email, password, rememberMe });
  }

  componentDidUpdate = (prevProps: any) => {
    const { loginReducer } = this.props;
    // To close the login popup modal
    // if (
    //   prevProps.loginReducer &&
    //   prevProps.loginReducer.isLoggedIn !== loginReducer.isLoggedIn &&
    //   loginReducer.isLoggedIn
    // ) {
    //   this.props.handleClose();
    // }
    // const { isLoggedIn } = loginReducer;
    // if (loginReducer.isLoggedIn == false) {
    //   console.log("quizSummary", isLoggedIn);
    //   this.setState({
    //     isLoggedIn: isLoggedIn,
    //   });
    // }
  };

  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type } = event.target;
    if (type === "checkbox") {
      const { checked } = event.target;
      this.setState({
        ...this.state,
        [name]: checked,
      });
    } else {
      this.setState({
        ...this.state,
        [name]: value,
      });
    }
    this.setState({
      errors: {
        ...this.state.errors,
        [name]: "",
      },
    });
  };

  handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const { email, password, rememberMe, isClick } = this.state;
    const data = {
      email: email ? email.trim().toLowerCase() : "",
      password,
      rememberMe
    };
    // To validate form fields
    const { isValid, errors } = loginValidator(data);
    if (isValid) {
      this.setState({
        isClick: true,
      });
      await this.props.onLogin(data);
      // this.props.handleClose();
    } else {
      this.setState({
        errors, 
      });
      console.log(errors);
      return;
    }    

    /*if(this.props.loginReducer) {
      console.log("from DB");
      this.setState({
        passwordCount: this.props.loginReducer.attempts  
      });
    } else {*/
    //}

  };

  // loginError = async (e: React.FormEvent<HTMLFormElement>) => {
  //   e.preventDefault();
  //   // To validate form fields
  //   const { isValid, errors } = loginValidator(data);
  //   if (isValid) {
  //     await this.props.onLogin(data);
  //     // this.props.handleClose();
  //   } else {
  //     this.setState({
  //       errors,
  //     });
  //     return;
  //   }
  // };

  render() {
    const { email, password, rememberMe, errors, isClick, } = this.state;
    const { loginReducer } = this.props;
    console.log("reducerrrrrrrr", loginReducer.isLoggedIn);
    return (
      <div className={"login-form login-main-wrap"}>
        {/* <h2>Get More things done with login</h2> */}
        <h5 className="login-heading">
          <span>Login</span>
        </h5>
        <Form onSubmit={this.handleSubmit}>
          <Form.Group controlId="formBasicEmail">
            <InputGroup>
              <input
                type={"text"}
                name={"email"}
                value={email}
                className={"form-control form-input"}
                placeholder=" "
                onChange={this.handleChange}
              />
              <Form.Label
                className={`login-form-label ${email ? "top-label" : ""}`}
              >
                Email Address{" "}
              </Form.Label>
              <span className="login-icon">
                <Image src={mailIcon} />
              </span>
            </InputGroup>
            <div className={"text-danger error-field"}>
              {errors && errors.email}
            </div>
          </Form.Group>
          <Form.Group controlId="formBasicPassword">
            <InputGroup>
              <input
                type={"password"}
                name={"password"}
                value={password}
                className={"form-control form-input"}
                placeholder=" "
                onChange={this.handleChange}
              />
              <Form.Label
                className={`login-form-label ${password ? "top-label" : ""}`}
              >
                Password
              </Form.Label>
              <span className="login-icon">
                <Image src={lockIcon} />
              </span>
              {!loginReducer.isLoggedIn && isClick && loginReducer.error ? (
                loginReducer.attempts > 4 ? (
                  <Alert
                    style={{ width: "25rem"}}
                    variant="danger"
                  >     
                  {(loginReducer.attempts > 5 ? (
                    <div>
                    <div>
                      Your account is locked now. <br></br>
                      <span
                        onClick={this.props.resetShow}
                        className="forget-link"
                      >
                        Click here
                      </span> to reset your password.
                    </div>
                    </div>
                  ) : (
                    <div>
                    <div>Your email or password is incorrect</div>
                    <div>
                      You have no more attempts, your account is locked now. <br></br>
                      <span
                        onClick={this.props.resetShow}
                        className="forget-link"
                      >
                        Click here
                      </span> to reset your password.
                    </div>
                    </div>
                  ))}               
                    
                    
                  </Alert>
                ) : ( 
                  <Alert
                    style={{ width: "24rem"}}
                    variant="danger"
                  >
                   Your email or password is incorrect
                  </Alert>
                )
              ) : (
                ""
              )}


              {/* <Alert variant="danger" style={{ width: "24rem", height:"1rem" }}>
              <Alert.Heading style={{ width: "14rem", height:"1rem" }}>
                This is a danger alert which has red background
              </Alert.Heading>
            </Alert> */}
              {/* <OverlayTrigger
                key={'top'}
                placement={'top'}
                overlay={
                  <Tooltip id={`tooltip`}>
                    Passwords are a minimum of 8 characters, and must contain an
                    uppercase letter, number, and special character
                  </Tooltip>
                }
              >
                <span className='login-info'>
                  <i className='fas fa-info' />
                </span>
              </OverlayTrigger> */}
            </InputGroup>

            <div className={"text-danger error-field"}>
              {errors && errors.password}
            </div>
          </Form.Group>
          {/* <ToggleButtonGroup type="radio" name="options" defaultValue={1} className="custom-toggle">
            <ToggleButton value={1} variant="link">Organization</ToggleButton>
            <ToggleButton value={2} variant="link">User</ToggleButton>
          </ToggleButtonGroup> */}
          <div className="clearfix" />
          <div className="text-center my-3">
            <Button type="submit" className="btn-submit login-btn">
              Login
            </Button>
          </div>

          <div className="remember-div">
            <Form.Check
              custom
              type="checkbox"
              name={"rememberMe"}
              checked={rememberMe}
              onChange={this.handleChange}
              id="custom-checkbox"
              label="Remember me"
              className="float-left"
            />
            <span
              onClick={this.props.forgotShow}
              className="forget-link float-right"
            >
              Forgot Password?
            </span>
          </div>
        </Form>
      </div>
    );
  }
}

export default Login;
